import React from 'react';

const preloaders = new Set();

export function preloadAll() {
  return Promise.all([...preloaders].map((preload) => preload()));
}

export default function createLazyComponent({ fallback = null, loader }) {
  let modulePromise;
  const load = () => {
    if (!modulePromise) {
      modulePromise = loader().then((module) => ({ default: module.default || module }));
    }
    return modulePromise;
  };
  const LazyComponent = React.lazy(load);

  preloaders.add(load);

  // A class wrapper preserves the public widget API's legacy ref contract: the
  // boot Promise resolves with the loadable wrapper instance, while loading is
  // delegated to React.lazy without deprecated lifecycle or context APIs.
  class LazyLoadableComponent extends React.Component {
    static preload = load;

    render() {
      return (
        <React.Suspense fallback={fallback}>
          <LazyComponent {...this.props} />
        </React.Suspense>
      );
    }
  }

  return LazyLoadableComponent;
}
